import { ChakraV3 } from '@piccolohealth/ui';
import { EditorContent, type Editor as TiptapEditor } from '@tiptap/react';
import React from 'react';
import { tiptapCss } from '../../theme/v3/tiptapCss';
import { CommentBubbleMenu } from './menus/comment/CommentBubbleMenu';
import { DragAndPlusButton } from './menus/DragAndPlusButton';
import { SearchAndReplaceMenu } from './menus/SearchAndReplaceMenu';
import { TableBubbleMenu } from './menus/TableBubbleMenu';

interface Props {
  editor: TiptapEditor | null;
}

export const Editor = (props: Props) => {
  const { editor } = props;

  return (
    <>
      <ChakraV3.Box flex={1} overflowY='auto' px={4} css={tiptapCss}>
        <ChakraV3.Box asChild className='csr' spellCheck='true' lang='en-GB'>
          <EditorContent editor={editor} />
        </ChakraV3.Box>
      </ChakraV3.Box>
      {editor?.isEditable && (
        <ChakraV3.Box>
          <TableBubbleMenu editor={editor} />
          <CommentBubbleMenu editor={editor} />
          <DragAndPlusButton editor={editor} />
          <SearchAndReplaceMenu editor={editor} />
        </ChakraV3.Box>
      )}
    </>
  );
};
